export default __webpack_public_path__ + "static/frame3-7fc3cc9b9bde0b00b84841727878a7e5.png";